import PersonalInfoWrapper from 'features/signup/PersonalInfo/PersonalInfoWrapper';
import React from 'react';

export default function SignupPersonalInfoPage() {
  return <PersonalInfoWrapper />;
}
